import styled from 'styled-components';
import theme from '../../../theme';

const SmallLabel = styled.div`
  color: ${theme.colors.dark};
  font-size: ${theme.fontSizes.small};
  a {
    color: ${theme.colors.dark};
    &:hover {
      color: ${theme.colors.primary};
    }
  }
`;

export default SmallLabel;
